import { cn } from "@/lib/utils";

// Shared loading placeholder. Use this in place of one-off `animate-pulse
// rounded bg-muted` divs so loading shapes stay visually consistent across
// the app. Compose multiple instances to match the post-load layout.
export function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      role="status"
      aria-busy="true"
      aria-label="Loading"
      className={cn("animate-pulse rounded-md bg-muted/60", className)}
      {...props}
    />
  );
}
